"use strict";

var _interopRequireDefault = require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _nhanh = require("@/api/nhanh");
var _sale = require("@/api/sale");
var _moment = _interopRequireDefault(require("moment"));
var _vuePropertyDecorator = require("vue-property-decorator");
var _DetailReport = _interopRequireDefault(require("./components/DetailReport.vue"));
var Report = /*#__PURE__*/function (_Vue) {
  function Report() {
    var _this;
    (0, _classCallCheck2.default)(this, Report);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, Report, [].concat(args));
    (0, _defineProperty2.default)(_this, "query", {
      date: (0, _moment.default)().clone().startOf("month").valueOf()
    });
    (0, _defineProperty2.default)(_this, "data", []);
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "loadingButton", false);
    (0, _defineProperty2.default)(_this, "totalOrder", 0);
    (0, _defineProperty2.default)(_this, "totalSale", 0);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "label", ["Tỉ trọng doanh số (%)", "Tỉ trọng số đơn (%)", "Tỉ lệ hủy đơn (%)", "Độ chuyên cần (%)", "Điểm số"]);
    return _this;
  }
  (0, _inherits2.default)(Report, _Vue);
  return (0, _createClass2.default)(Report, [{
    key: "transformTable",
    get: function get() {
      var _this2 = this;
      if (!this.data.length) {
        return [];
      }
      var data = [];
      var list = {};
      this.data.forEach(function (e) {
        var ratioTotalSale = e.totalSale / _this2.totalSale;
        var ratioTotalOrder = e.totalOrder / _this2.totalOrder;
        var ratioWorkDays = e.realWorkDays / e.workDays;
        var total = ratioWorkDays * (ratioTotalSale + ratioTotalOrder - e.ratioCancelOrder);
        var temp = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, e), {}, {
          ratioTotalSale: ratioTotalSale,
          ratioTotalOrder: ratioTotalOrder,
          ratioWorkDays: ratioWorkDays,
          total: total
        });
        data.push(temp);
      });
      // for (let i = 0; i < this.data.length; i++) {
      //   const e = this.data[i];
      //   let ratioTotalSale = e.totalSale / this.totalSale;
      //   let ratioTotalOrder = e.totalOrder / this.totalOrder;
      //   let ratioWorkDays = e.realWorkDays / e.workDays;
      //   let total =
      //     ratioWorkDays * (ratioTotalSale + ratioTotalOrder - e.ratioCancelOrder);
      //   list[i] = [
      //     e.id,
      //     ratioTotalSale,
      //     ratioTotalOrder,
      //     e.ratioCancelOrder,
      //     ratioWorkDays,
      //     total,
      //   ];
      // }
      // for (let i = 0; i < this.label.length; i++) {
      //   const e = this.label[i];
      //   let temp = { label: e };
      //   for (let j = 0; j < this.data.length; j++) {
      //     temp[list[j][0]] = list[j][i + 1];
      //   }
      //   data.push(temp);
      // }
      return data;
    }
  }, {
    key: "created",
    value: function () {
      var _created = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.fetchData();
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function created() {
        return _created.apply(this, arguments);
      }
      return created;
    }()
  }, {
    key: "handleView",
    value: function handleView(row) {
      this.$refs.detailReport.handleView(row);
    }
  }, {
    key: "fetchOrderInMonth",
    value: function () {
      var _fetchOrderInMonth = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var startOfMonth, j, i, curr, next;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.loadingButton = true;
              startOfMonth = (0, _moment.default)(this.query.date).clone().startOf("month");
              _context2.prev = 2;
              j = 0;
              i = 0;
            case 5:
              if (!(i < 3)) {
                _context2.next = 14;
                break;
              }
              j = i;
              curr = startOfMonth.clone().add(10 * j, "days").format("YYYY-MM-DD");
              next = startOfMonth.clone().add(10 * (i + 1), "days").format("YYYY-MM-DD");
              _context2.next = 11;
              return _nhanh.nhanhApi.findAllOrders({
                fromDate: curr,
                toDate: next
              });
            case 11:
              i++;
              _context2.next = 5;
              break;
            case 14:
              this.fetchData();
            case 15:
              _context2.prev = 15;
              this.loadingButton = false;
              return _context2.finish(15);
            case 18:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[2,, 15, 18]]);
      }));
      function fetchOrderInMonth() {
        return _fetchOrderInMonth.apply(this, arguments);
      }
      return fetchOrderInMonth;
    }()
  }, {
    key: "fetchData",
    value: function () {
      var _fetchData = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _sale.saleApi.report({
                date: this.query.date / 1000
              });
            case 2:
              res = _context3.sent;
              this.data = res.data.sales;
              this.totalSale = res.data.totalSale;
              this.totalOrder = res.data.totalOrder;
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function fetchData() {
        return _fetchData.apply(this, arguments);
      }
      return fetchData;
    }()
  }]);
}(_vuePropertyDecorator.Vue);
Report = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    DetailReport: _DetailReport.default
  }
})], Report);
var _default = exports.default = Report;